import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from '../../Theme';

/**
 * Import Themes
 */

import chipCommonTheme from './_common';
import chipBlogTheme from './_blog';
import chipSiteTheme from './_site';
import { ChipThemeProps } from '../types/_theme';

/**
 * Group Themes
 */

const chipThemes = (args: ChipThemeProps) =>
  new MatchedMap([
    [ThemeEnum.Blog, chipBlogTheme],
    [ThemeEnum.Site, chipSiteTheme(args)],
  ]);

/**
 * Theme Hook
 */

const useChipTheme = (args: ChipThemeProps) => useTheme(chipCommonTheme, chipThemes(args));

export default useChipTheme;
